import { AuthRoute } from '@/system-modules/auth/v1/api/AuthRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'

export class LogoutRoute extends AuthRoute<null, null> {
  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/system/v1/auth/logout'
  }

  offline(): Promise<ApiResponse<null>> {
    return Promise.resolve(new ApiResponse({ success: true, data: null }))
  }
}
